import {useEffect} from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {DrugDetails, DrugList, Pharmacy, PharmacyDetails} from 'screens';
import {useAppSelector} from 'store/hooks';

function AuthenticatedRoutes() {
  const {isLoggedIn} = useAppSelector((state) => state.login);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login');
    }
  }, [isLoggedIn, navigate]);
  return !isLoggedIn ? (
    <h1>Redirecting to login...</h1>
  ) : (
    <Routes>
      <Route path="/pharmacy" Component={Pharmacy} />
      <Route path="/pharmacy-details" Component={PharmacyDetails} />
      <Route path="/drug-list" Component={DrugList} />
      <Route path="/drug-details" Component={DrugDetails} />
    </Routes>
  );
}

export default AuthenticatedRoutes;
